import { curry1 } from './curry1';
import { curry2 } from './curry2';
import { curry3 } from './curry3';
export function curry4(fn) {
    function curried(a, b, c, d) {
        switch (arguments.length) {
            case 0: return curried;
            case 1: return curry3(function (b, c, d) { return fn(a, b, c, d); });
            case 2: return curry2(function (c, d) { return fn(a, b, c, d); });
            case 3: return curry1(function (d) { return fn(a, b, c, d); });
            default: return fn(a, b, c, d);
        }
    }
    return curried;
}
//# sourceMappingURL=curry4.js.map